import { privateRoutes, publicRoutes } from '@fd/backend/config/routes';
import { ENVIRONMENTS } from '@fd/common/environment';
import { hc } from 'hono/client';
import { determineEnv } from '@fd/common/api/determineEnv';
import { getAccessToken } from '../auth/user';
import { supabase } from '@fd/supabase/index';
import { logout } from '../auth/logout';

async function fetchWithInterceptor(
  input: URL | RequestInfo,
  requestInit?: RequestInit
) {
  const headers = {
    'Content-Type': 'application/json; charset=utf-8',
    Authorization: `Bearer ${await getAccessToken()}`,
  };
  if (requestInit)
    requestInit.headers = {
      ...requestInit.headers,
      ...headers,
    };
  const response = await fetch(input, requestInit);
  if (response.status === 401) {
    const { data } = await supabase.auth.refreshSession();
    if (!data.session) {
      await logout();
      return new Response();
    }
    if (requestInit) {
      requestInit.headers = {
        ...requestInit.headers,
        'Content-Type': 'application/json; charset=utf-8',
        Authorization: `Bearer ${data.session.access_token}`,
      };
      return await fetch(input, requestInit);
    }
  }
  return response;
}

export const honoPrivateClient = hc<typeof privateRoutes>(
  ENVIRONMENTS[determineEnv()].nodeBackendUrl,
  {
    fetch: fetchWithInterceptor,
  }
);

export const honoPublicClient = hc<typeof publicRoutes>(
  ENVIRONMENTS[determineEnv()].nodeBackendUrl
);
